import React from "react"
import Button from "@/components/core/Button/Button"
import configuratorIcon from "@/styles/images/configurator-icon.svg"

const Cofigurator = props => {
  const {
    title = "",
    description = "",
    buttonLabel = "",
    handleButtonClick = () => {},
  } = props

  const handleClick = e => {
    e.preventDefault()
    handleButtonClick()
  }

  return (
    <div className="configurator">
      <h5 className="configurator-title">{title}</h5>
      <p className="configurator-description">{description}</p>
      <Button
        type="ghost"
        role="button"
        label={buttonLabel}
        className="configurator-btn"
        icon={configuratorIcon}
        iconClass="icon"
        onClick={handleClick}
        flexible
      />
    </div>
  )
}

export default Cofigurator
